import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NamedTemplateDirective } from 'src/app/directives/named-template.directive';
import { TargetBlankDirective } from './target-blank.directive';
import { CircularProgressBarGradientDirective } from './circular-progress-bar-gradient.directive';
import { NumericDirective } from 'src/app/directives/numeric.directive';
import { TableDirective } from './table/table.directive';
import { TableHeadDirective } from './table/table-head.directive';
import { TableRowDirective } from './table/table-row.directive';
import { TableRowContentDirective } from './table/table-row-content.directive';
import { TableCellDirective } from './table/table-cell.directive';
import { MultiSelectDirective } from './multi-select.directive';
import { TrimDirective } from 'src/app/directives/trim.directive';
import { ClickStopPropagationDirective } from 'src/app/directives/click-stop-propagation.directive';
import { DatepickerDirective } from './datepicker.directive';
import { TitlecaseDirective } from './titlecase.directive';

@NgModule({
  declarations: [
    TargetBlankDirective,
    NamedTemplateDirective,
    CircularProgressBarGradientDirective,
    NumericDirective,
    MultiSelectDirective,
    TrimDirective,
    ClickStopPropagationDirective,
    TableDirective,
    TableHeadDirective,
    TableRowDirective,
    TableRowContentDirective,
    TableCellDirective,
    DatepickerDirective,
    TitlecaseDirective
  ],
  exports: [
    TargetBlankDirective,
    NamedTemplateDirective,
    CircularProgressBarGradientDirective,
    NumericDirective,
    MultiSelectDirective,
    TrimDirective,
    ClickStopPropagationDirective,
    TableDirective,
    TableHeadDirective,
    TableRowDirective,
    TableRowContentDirective,
    TableCellDirective,
    DatepickerDirective,
    TitlecaseDirective
  ],
  imports: [
    CommonModule
  ]
})
export class DirectivesModule { }
